import lang from "element-ui/lib/locale/lang/en"; // 引入element语言包
const messages = {
  极兔开放平台: "J & T  OPEN PLATFORM",
  帮助中心: "HELP",
  "注 册": "Register",
  快递轨迹查询: "Tracking Query",
  新增订单: "Create Order",
  取消订单: "Cancel Order",
  查询订单: "Check Order",
  打印订单: "Waybill Model",
  "物流轨迹订阅（新）": "Logistics Tracking Subscription(New)",
  物流轨迹回传: "Logistics Tracking Return",
  订单状态回传: "Order Return Status",
  退回件申请: "Return application",
  indexPage: {
    title: "Cloud warehouse services docking technology platform",
    BannerTxt:
      "Sharing various service of J&T Cloud Warehouse, helping enterprises to efficiently complete inbound and outbound operations, pushing order's status automatically, and providing services such as inventory and tracking query.",
    BannerBtnTxt: "Join J & T open platform"
  },
  apiService: {
    titleleft: "Inbound",
    textLeft1: "Create inbound order",
    textLeft2: "Get the inbound status and inventory",
    titleRight: "Outbound",
    textRight1: "Create outbound order",
    textRight2: "Get the outbound status and logistics tracking"
  },
  helpCenter: {
    电商平台列表:"Source platform code",
    来源平台:'Source platform',
    平台代码:"Platform code",
    描述: "Description",
    虾皮:'Shopee',
    来赞达:'Lazada',
    京东印尼站:'JD Indonesia',
    京东泰国站:'JD Thailand',
    Shopify独立站:'Shopify',
    Shopline独立站:'Shopline',
    速卖通:'AliExpress',
    敦煌网:'DHgate',
    希音:'Shein',
    沃尔玛:'WALMART',
    UEESHOP独立站:'UEESHOP',
    SHOPLAZZA独立站:'SHOPLAZZA',
    亚马逊:'AMAZON',
    非上述平台:"Platforms not mentioned above",
    carrier_des:'The carrier parameter in the outbound order creation interface can be found on this page.',
    country_des:'For information on countrycode and pricecurrency in the outbound order creation interface, please refer to this page.',
    错误码: "Error Code",
    接入指南: "Get the eccompanyid and key",
    "国家/币种编码": "Country/Currency Code",
    承运商映射: "Carrier Code",
    WMS承运商编码: "Carrier Code",
    简称: "Abbreviation",
    签名工具: "Signature tool",
    电子面单模板: "Electronic face sheet template",
    "API-SDK说明": "API-SDK description",

    method_1:
      "1. Use the http protocol form submission method for information interaction, the character encoding is unified by UTF-8 by default, and the data format: application/x-www-form-urlencoded;",
    method_2:
      "2. apiAccount and privateKey are provided by the platform; digest=base64(md5 (Json+privateKey of business parameters)), note: first md5 gets the byte array, and then base64 encryption;",
    method_3: `3. For example: base64(MD5({"age":18,"gender":"male","name":"zhangsan"}123456)) If the signature is wrong, you can encode the URL and send the request.`,
    method_4:
      "4. Field type convention: development should be carried out in strict accordance with the parameter format and size given in the field table.",
    method_5:
      "5. Field resolution conventions: the required fields in the parameter fields are required to be passed in every time the interface is called;",
    method_6:
      "6. For part of the interface sample code and SDK, please refer to the sample code and SDK documentation.",
    业务参数签名: "Business parameter signature",
    请输入加密后的32位pwd: "Please input the 32-bit encrypted pwd",
    获取: "Get",
    Headers签名: "Headers signature",
    bussness:
      "Example: When calling the interface of placing an order, canceling an order, etc., the business parameter <code>digest</code> is required, and the business parameter <code>digest</code> has a different meaning from the <code>digest</code> in the global Headers.",

    bussness_1: `First of all, Jitu will assign an account and password required by the agreement customer to place an order. For example: <code>J0086024071</code>/<code>BaMCAx11</code>, where <code>pwd</code> is equal to <code>MD5 (plain text password (BaMCAx11)+jadada236t2)</code>
    After capitalization, for example, the 32-bit <code>pwd</code> generated by this example is <code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>, and finally the business parameter signature is generated according to the rule Base64 (Md5 (customer number + cipher text + privateKey)).`,
    bussness_2: `That is: business parameter signature <code>digest</code>=Base64(Md5(<code>J0086024071</code>+<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>+privateKey))`,
    headers_1: `Example: Take cancellation of an order as an example: suppose the business parameter is bizContent as <code>{"txlogisticId":"SA71398747473","orderType":2,"reason":"jiushixiangquxiaoyouruhe","customerCode":"J0086024071"} </code>, then the signature digest in the header at this time is equal to <code>base64(md5(Json+privateKey of business parameters))</code>,`,
    headers_2: `That is <code>base64(md5({"txlogisticId": "SA71398747473", "orderType": 2, "reason": "jiushixiangquxiaoyouruhe", "customerCode": "J0086024071", "digest": "4hQ8qXNkuSJ8cIgJQDFFRA=="}+privateKey))</code>.`,
    headers_3: `Note: <code>privateKey</code> is automatically assigned after the account is authenticated by the platform`,
    一联模版: "One-page template",
    // 国家/币种编码: "Currency",
    Introduction: "1.Introduction",
    sdk_two: "2. Version update record",
    sdk_3_title: "3. Quick Start Install API Open Platform SDK",
    sdk_4_title: "4. API-SDK directory structure",
    sdk_5_title: "5. JAR package directly following steps:",
    sdk_6_title: "6. SDK related maven dependencies",
    sdk_7_title: "7. Create JtExpressApi",
    sdk_8_title: "8. Suggestion",
    Introduction_1: "Hi, hello, and welcome to use the API open platform.",
    Introduction_2:
      "This document is mainly aimed at platform developers and describes the relevant technical content of the express service technology docking platform. If you have any questions about the content of the document, you can contact the platform operation to answer the question.",
    date: "date",
    sdkVersion: "version number",
    updata: "Updates",
    updataInfo:
      "It provides a common interface standard to call an open platform, supporting the completion of the interface signature",
    语言: "Language",
    最新版本: "Latest version",
    项目示例: "Project example",
    开发环境: "Development environment",
    支持JAVA版本: "Support JAVA version: 1.8+",
    支持PHP: "Support PHP7.0 and above",
    签名相关类: "Signature related classes",
    公用类: "Public class",
    异常相关类: "Exception related class",
    Http通信相关类: "Http communication related classes",
    开放平台api通用接口: "Open platform api general interface",
    执行器接口: "Actuator interface",
    sdk_5_txt: `<p>1. The SDK compression toolkit is provided by the open platform. </p>
    <p>2. Unzip the "jt-openapi-sdk.zip" provided by the open platform and copy it to the project folder. </p>
    <p>3. Click File -> Project Structure (shortcut key Ctrl + Alt + Shift + s), click "Modules on the left side of the Project Structure interface.</p>
    <p>4. In the "Dependencies" tab interface, click the "+" sign on the right, select the first option "JARs or directories...", select the corresponding jar package, click "OK", the jar package is added successfully . </p>
    <p>5. The SDK calling method of the specific interface can be downloaded for reference. </p>`,
    sdk_6_txt:
      "SDK uses slf4j-api package for log output by default; SDK uses fastjson for json data conversion by default; SDK uses httpclient for http data transmission by default.",
    sdk_7_txt: `<p>JtExpressApi is the J&T open platform api general executor, which provides a series of interactive methods for developers who use the J&T open platform. </p>
    <p>Users can refer to the following code to create a new JtExpressApi. After the initialization is completed, it is recommended to use a singleton to avoid repeated creation:</p>`,
    sdk_8_txt: `<p>If you use the springboot framework to call API open platform-SDK related interfaces, it is recommended to put JtExpressApi in the spring container for management,</p>
    <p>Users can refer to the following code to create a new configuration class:</p>`,
     // 系统级错误 (S*)
  S01: "Illegal JSON format [logistics_interface data does not conform to JSON format standard]",
S02: "Illegal digital signature [data_digest signature is incorrect, failed verification]",
S03: "Illegal logistics company [eccompanyid is incorrect, failed verification]",
S04: "Illegal notification type [msg_type value is not within the range specified in the documentation]",
S05: "Illegal notification content [content format in logistics_interface is incorrect]",
S06: "Connection timeout [considered timeout if no response is received within 30 seconds when creating an order]",
S07: "System exception, please retry [database exception or other system errors, need to contact development for handling]",
S08: "Illegal e-commerce platform [eccompanyid error]", // Note: This is a specific error, not a duplicate of S07
S09: "No task data returned [returned when there are no records for freight query, package tracking query]",
S10: "Order number duplicate [txlogisticid order number duplicate in online ordering interface]",
S11: "Waybill number duplicate [mailno waybill number duplicate in online ordering interface]",
S12: "Order status GOT cannot cancel order [order update interface, cannot cancel order when order has been received]",
S13: "Customer identifier error [customerid value error in online ordering interface, customer does not exist in system]",
S14: "Waybill number segment error [waybill number segment has been used up or not yet issued]",
S18: "Warehouse enablement setting error, please contact administrator [warehouse enablement setting error, please contact administrator]",
S101: "Parameter is empty",
S200: "IP access denied",
S399: "System exception!",
S3001: "System exception",
B300: "Parameter cannot be empty!",
B301: "[customerid] consignor code cannot be empty!",
B302: "[warehouseCode] warehouse code cannot be empty!",
B303: "[goodsLong] goods length cannot be empty!",
B304: "[goodsWidth] goods width cannot be empty!",
B305: "[goodsHeight] goods height cannot be empty!",
B306: "[weight] goods weight cannot be empty!",
B307: "[unitPrice] unit price cannot be empty!",
B308: "[currencyId] currency type is incorrect!",
B309: "[barcodes] barcode collection cannot be empty!",
B310: "[barcode] barcode cannot be empty!",
B311: "[electricityCapacity] electricity capacity cannot be empty!",
B312: "[expirationType] expiration type cannot be empty!",
B313: "[expirationDate] expiration days cannot be empty!",
B314: "[unit] unit name is incorrect!",
B315: "[itemCode] item code cannot be empty!",
B316: "[itemName] item name cannot be empty!",
B317: "[shortName] item English name cannot be empty!",
B318: "[quantityUM] quantity unit cannot be empty!",
B319: "[startPage] start page cannot be empty!",
B320: "[pageSize] page size cannot be empty!",
B321: "[orderType] document type is incorrect!",
B322: "[orderCode] order code cannot be empty!",
B323: "[cancelReason] cancellation reason cannot be empty!",
B324: "Failed to cancel outbound order, outbound order not found!",
B325: "Failed to cancel outbound order, outbound order number is empty!",
B326: "[command] query command cannot be empty!",
B327: "[serialnumber] outbound order code cannot be empty!",
B328: "[txlogisticid] customer order number cannot be empty",
B329: "[ordertype] order type cannot be empty!",
B330: "[sender.name] sender name cannot be empty!",
B331: "[sender.mobile] sender mobile cannot be empty!",
B332: "[sender.phone] sender phone cannot be empty!",
B333: "[sender.countrycode] sender country code cannot be empty!",
B334: "[sender.prov] sender province cannot be empty!",
B335: "[sender.city] sender city cannot be empty!",
B336: "[sender.area] sender area cannot be empty!",
B337: "[sender.address] sender address cannot be empty!",
B338: "[sender] sender information object cannot be empty!",
B339: "[receiver] receiver information object cannot be empty!",
B340: "[receiver.address] receiver address 1 cannot be empty!",
B341: "[receiver.area] receiver district/county cannot be empty!",
B342: "[receiver.city] receiver city cannot be empty!",
B343: "[receiver.prov] receiver province cannot be empty!",
B344: "[receiver.countrycode] receiver country cannot be empty!",
B345: "[receiver.name] receiver name cannot be empty!",
B346: "[receiver.phone] receiver phone cannot be empty!",
B347: "[receiver.mobile] receiver mobile cannot be empty!",
B348: "[transport] transportation method cannot be empty!",
B349: "[itemsvalue] goods amount cannot be empty!",
B350: "[pricecurrency] goods currency (COD) cannot be empty!",
B351: "[routeid] route ID cannot be empty!",
B352: "[totalquantity] total quantity cannot be empty!",
B353: "[items] item list cannot be empty!",
B354: "[items.itemvalue] item price cannot be empty and cannot be 0!",
B355: "[carrier] carrier cannot be empty!",
B356: "[mailno] waybill number cannot be empty!",
B357: "WMS request exception!",
B358: "Item information validation interface request exception!",
B359: "[startdate] start time and [enddate] end time cannot be empty!",
B360: "[entryOrderCode] inbound order code cannot be empty!",
B361: "[expectStartTime] expected arrival date cannot be empty!",
B362: "[quantity] planned inbound quantity cannot be empty!",
B363: "[number] outbound quantity cannot be empty!",
B364: "[label] waybill URL and [mailno] waybill number cannot be empty!",
B365: "[label] waybill URL is invalid!",
B366: "[country] country cannot be empty!",
B367: "Item details not maintained!",
B368: "[receiver.countrycode] country code does not exist!",
B369: "When [mailno] waybill number exists, [label] waybill URL cannot be empty!",
B370: "[status] status type is incorrect!",
B371: "[command] query command type is incorrect!",
B372: "Start time cannot be greater than end time!",
B373: "Time format is incorrect!",
B374: "Inbound order information cannot be empty!",
B375: "[label] waybill URL cannot be empty!",
B376: "Failed to obtain cloud warehouse domain name!",
B377: "Failed to call WMS interface!",
B378: "Warehouse information for the consignor not found!",
B379: "Failed to create items in multiple warehouses!",
B380: "Failed to obtain item creation results in multiple warehouses!",
B381: "[expressBillFlag] input value is invalid!",
B3001: "Parameter cannot be empty",
B3002: "[header] waybill request header cannot be empty!",
B3003: "[details] waybill request details cannot be empty!",
B3004: "[erpOrderCode] ERP order number cannot be empty!",
B3005: "[ShipFromName] sender name cannot be empty!",
B3006: "[shipFromMobile] sender mobile number cannot be empty!",
B3007: "[shipFromPhoneNum] sender mobile number cannot be empty!",
B3008: "[shipFromCountry] sender country cannot be empty!",
B3009: "[shipFromState] sender state cannot be empty!",
B3010: "[shipFromCity] sender city cannot be empty!",
B3011: "[shipFromAddress] sender detailed address cannot be empty!",
B3012: "[ShipToName] receiver name cannot be empty!",
B3013: "[shipToMobile] receiver mobile number cannot be empty!",
B3014: "[shipToPhoneNum] receiver mobile number cannot be empty!",
B3015: "[shipToCountry] receiver country cannot be empty!",
B3016: "[shipToState] receiver state cannot be empty!",
B3017: "[shipToCity] receiver city cannot be empty!",
B3018: "[shipToAddress] receiver detailed address cannot be empty!",
B3019: "[totalWeight] total package weight cannot be empty!",
B3020: "[totalWeight] total package weight cannot be greater than or equal to 30kg!",
B3021: "[totalQty] total package quantity cannot be greater than or equal to 999!",
B3022: "[created] creation time cannot be empty!",
B3023: "[operateType] operation type cannot be empty!",
B3024: "[GoodsCategory] goods category cannot be empty!"
  },
  controlPage: {
    审核状态: "Review status",
    请选择国家: "Please select country",
    请输入酋长国: "Please enter city",
    请输入区域: "Please enter district",
    公司详细地址: "Company address",
    请输入社会信用代码: "Please enter license number",
    请上传营业执照: "Please upload image of business license",
    请输入法人身份证: "Please enter ID number of corporation",
    身份证详细地址: "ID address",
    请选择证件类型: "Please select a certificate type"
  },
  message: {},
  apiDoc: {
    搜索菜单: 'Search menu',
    未找到匹配的菜单项: 'No matching menu item found',
    极兔API简介: "Introduction to J&T API",
    订单服务: "Order Service",
    创建订单: "Create Order",
    查询订单: "Check Order",
    取消订单: "Cancel Order",
    订单状态回传: "Order Return Status",
    退回件申请: "Return application",
    退换货接口: "Return and exchange",
    散客寄件: "Individual shipment",
    物流轨迹: "Logistics Tracking",
    物流轨迹查询: "Logistics Tracking Query",
    三段码查询: "Three-segment code search",
    物流轨迹订阅: "Logistics Tracking Subscription",
    物流轨迹回传: "Logistics Tracking Return",
    API简介: "API introduction",
    参考案例: "java Reference Case",
    复制代码: "Copy Code",
    复制成功: "Copy success",
    复制失败: "Copy failed",
    类型: "类型",
    ORDERCREATE_desc: "Order Creation Interface",
    ORDERCANCEL_desc: "Order Cancellation Interface",
    FREIGHTQUERY_desc: "Freight Query Interface",
    TRACKQUERY_desc: "Tracking Query Interface",
    ROTAPRINT_desc: "Electronic Waybill Printing Interface",
    QUERYWAREHOUSE_desc: "Return Warehouse Inventory Query Interface",
    QUERYORDER_desc: "Order Information Query Interface",
    QUERYORDERSTATUS_desc: "Order Status Query Interface",
    OBTAINPROVCITYAREA_desc: "Province-City-Area Data Interface",
    OBTAINPOSITION_desc: "Warehouse Position Data Interface",
    OBTAINDIFFICULT_desc: "Difficult Item Data Interface",
    OBTAINTRANSPORT_desc: "Transport Method Data Interface",
    OBTAINROUTEDATA_desc: "Route Data Interface",
    OBTAINWAREHOUSE_desc: "Warehouse Information Interface",
    OBTAINPRODUCTTYPES_desc: "Product Type Data Interface",
    SINGLEITEMCREATE_desc: "Product Data Creation Interface",
    ENTRYORDERCREATE_desc: "Inbound Order Creation Interface",
    QUERYENTRYORDER_desc: "Inbound Order Query Interface",
    CREATESTOCKOUTORDER_desc: "Outbound Order Creation Interface",
    STOCKOUTORDERQUERY_desc: "Outbound Order Query Interface",
    INVENTORYQUERY_desc: "Inventory Query Interface",
    QUERYREPORT_desc: "Report Query Service",
    QUERYBILLINFO_desc: "Customer Bill Query Interface",
    UPLOADINVOICE_desc: "Order Invoice Upload",
    SORTCODE_desc: "Sorting Code Query",
    IMEIQUERY_desc: "IMEI Query",
    QUERYRATE_desc: "Exchange Rate Query",
    UPLOADFILE_desc: "Weight Image Upload",
    UPDATEORDERWEIGHT_desc: "Secondary Forecast Weight Modification",
    INVENTORYCALLBACK_desc: "Inventory Change Callback",
    STOCKOUTORDERCALLBACK_desc: "Outbound Order Callback",
    title_1: "Get the eccompanyid and key",
    text_11:
      "For UAT environments, you can use the reference examples in the specific API documentation. For production environments, you need to obtain them from technical support in advance.",
    text_12: "For example, the obtained eccompanyid and key are as follows:",
    text_13: "eccompanyid和秘钥key的获取方式：",
    title_2: "Understand the specific meaning of interface protocol parameters",
    table_21: "Properties",
    table_22: "Description",
    text_22: "The msg_type include the following:",
    title_3: "Sign the JSON content and the key.",
    MSG类型: "msg_type",
    text_31:
      "Signing algorithm: First, perform MD5 signing to obtain 32 lowercase characters, then perform BASE64 signing to obtain the result. UTF-8 character encoding is used.",
    text_32: `logistics_interface={"weight":"1","destAreaCode":"KALIDERES","sendSiteCode":"JAKARTA","feeType":"CHARGE","productType":"EZ"}`,
    text_33: "key=a620da4a08f8da77090b45ebea823f63",
    text_34:
      'data_digest = new String(Base64.encodeBase64(MD5Util.code32(logistics_interface + key, "UTF-8").getBytes("UTF-8")));',
    text_35:
      "The data_digest obtained above is: NjZhYWU3ZjIyZTZmZjJiYWJkNWE4NDc5ZDllZDRiMjA=",
    title_4: "Sending an HTTP POST request",
    text_41: "HTTP POST requests require placing parameters in the",
    text_42: "form-data",
    text_43: "before transmitting the data",
    text_44:
      "Note: Do not use the JSON body method to pass parameters; otherwise, an S01 error will occur.",
    text_45: "Request Example",
    IntroductionContent:
      "In order to have better service to our customers, J&T Open Platform provides a standardized and unified access API to directly realize data interaction between customers and the platform and improve the convenience of both parties. This platform will prove a detailed description of the accessing processes and steps to facilitate customers to access the API platform more quickly and accurately.",
    对接流程: "Integration process",
    process_1: "1. Registration: To register as a member of J&T Open Platform.",
    process_2:
      "2. Application: Apply to be the developer and complete the developer information, then become a developer of J&T Open Platform.",
    // process_3: "3. Enterprise Certification:  Complete the enterprise information to receive all the interface permissions like order service, electronic waybill service, etc.",
    // process_4: "4. Joint Debugging and Testing: debugging test environment of API services, then to communicate with our API service personnel to solve problems.",
    // process_5: "5. Publishment: After passing the joint debugging test, contacting our API service personnel to confirm the publishment details.",
    接入指南: "Get the eccompanyid and key",
    method_1:
      "1. Use the http protocol form submission method for information interaction, the default character encoding form is UTF-8. Data format: application/x-www-form-urlencoded;",
    method_2:
      "2. apiAccount and privateKey are provided by the platform; digest=base64(md5 (Json+privateKey from the business parameters)), note: first md5 gets the byte array, and then encrypt by base64;",
    method_3: `3. For example: base64(MD5({"age":18,"gender":"male","name":"zhangsan"}123456)) If the signature is wrong, you can encode the URL and send the request.`,
    method_4:
      "4. Field type convention: development should be carried out in strict accordance with the parameter format and size given in the field table.",
    method_5:
      "5.  Field resolution conventions: the required fields in the parameter fields are required to be passed in every time the interface is called;",
    method_6:
      "6. For part of the interface sample code and SDK, please refer to the sample code and SDK documentation.",
    在线文档: "Online documentation",
    测试工具: "test tools",
    失败: "failure",
    Headers签名失败: "headers signature verification failed",
    内部调用异常: "Internal call exception",
    apiAccount为空: "apiAccount is empty!",
    digest为空: "digest is empty!",
    timestamp为空: "timestamp is empty!",
    系统错误: "System error",
    非法参数: "Illegal parameters",
    面单模版查询: "Waybill Model",
    其他服务: "Other services",
    快件预报: "Shipping Forecast",
    快件预报删除: "Shipment forecast deletion",
    航空预报: "Aeronautical Forecast",
    预估运费查询: "Estimated freight query",
    代收货款订阅: "Payment for goods subscription",
    代收货款回传: "Receipt of payment for goods",
    "面单模版查询（新）": "Waybill Template Search (New)",
    预约派送: "Rechedule Delivery",
    出口国际件: "Export international shipments",
    // ------------新加部分------------
    货品: "Item",
    创建货品: "Create Item",
    查询货品: "Search Item",
    单据: "Order",
    创建入库单: "Create Inbound Order",
    查询入库单: "Search inbound Orders",
    入库单状态回传: "Inbound order status callback",
    创建出库单: "Create outbound order",
    查询出库单: "Search outbound orders",
    出库单状态回传: "Outbound order status callback",
    单据取消: "Cancel order",
    基础资料: "Basic Info",
    入库:"Inbound",
    出库:'Outbound',
    取消:"Cancel",
    全程跟踪:"Trace tracking",
    设备:'Equipment',
    // --------库存-------
    库存: "Inventory",
    库存查询: "Get inventory",
    库存快照查询: "Get historical inventory",
    库存异动回传: "Inventory change callback",
    // ----------其他------------
    其他: "Other",
    查询备货仓库: "Search stock warehouse",
    查询出库单轨迹: "Get outbound order tracking",
    合单预报: "Combined orders forecast",
    设备登录: "Device Login",
    称重设备上传重量: "Weighing equipment uploads weight",
    容器绑定: "Container Bind"
  },
  apiDocDesc: {
    testUrl: "Overseas UAT address:",
    proUrl: "Overseas production address:",
    testUrlCn: "Domestic UAT address:",
    proUrlCn: "Domestic production address:",
    // -----创建货品
    itemDesc: "To create/modify product information through this API.",
    itemCodeDesc1: "Product Code",
    customeridDesc2: "Owner ID",
    actionTypeDesc3:
      "add=Add Information update=Edit Information (Does not support modification of product English name)",
    warehouseCodeDesc4: "Warehouse Code (Required for US warehouse)",
    itemNameDesc5: "Product Chinese Name",
    shortNameDesc6: "Product English Name",
    userDef1: "Product Alias", // 货品简称
    parentCode: "Item No.",    // 货号 (或 Item Code)
    itemStyle: "Specs",        // 规格 (或 Specification)
    packingClass: "Category",  // 类别
    netWeight: "Net Weight",   // 净重
    csDescNormal: "Case/Bag",  // 箱、包
    csDesc: "Case Display Name", // 箱显示名称
    isFragile: "Fragile (0-No, 1-Yes)",     // 是否易碎品
    isHazardous: "Hazardous (0-No, 1-Yes)", // 是否危险品
    isLiquid: "Liquid (0-No, 1-Yes)",       // 是否液体
    originAddress: "Country of Origin",     // 商品原产地 (贸易术语通常用这个)
    approvalNumber: "Approval No." ,         // 批准文号
    sizeDesc7: "Size",
    colorDesc8: "Color",
    goodsLongDesc9: "Minimum Unit Length, 2 decimal places, 0.01-9999",
    goodsWidthDesc10: "Minimum Unit Width, 2 decimal places, 0.01-9999",
    goodsHeightDesc11: "Minimum Unit Height, 2 decimal places, 0.01-9999",
    weightDesc12: "Minimum Unit Weight, 3 decimal places, 0.001-9999",
    imageUrlDesc13: "Image URL",
    itemTypeDesc14:
      "Product Type (ZC=Normal Product; BC=Packaging Material; OTHER=Other; Only English Codes Supported) Configurable, default is ZC",
    boxQtyDesc15: "Carton Packaging Quantity",
    unitDesc16: "Minimum Quantity Unit Name",
    packageUnitDesc17: "Packaging Unit",
    isElectricityDesc18: "Electrified, 0-No 1-Yes",
    electricityCapacityDesc19:
      "Electrical Capacity (Wh), required when IsElectricity = 1",
    expirationDesc20: "Management Expiration Date, 0=No 1 = Yes",
    expirationDateDesc21:
      "Validity period (required if validity period control is selected)",
    rejectLifecycleDesc22: "Receipt warning days",
    lockupLifecycleDesc23: "Prohibition period days",
    adventLifecycleDesc24: "Near-expiration warning days",
    isSNMgmtDesc25: "Manage serial numbers, 0-No 1-Yes, default is No",
    SNMgmtDesc26:
      "Serial number management method 0=Inbound/Outbound 1=Outbound only;Required if serial number management is selected as Yes",
    reserved1Desc27:
      "Reserved fields, customized field set, internal fields are pushed according to data type",
    barcodeDesc28: "Barcode",
    "barcodes[]/barcode": "-",
    quantityUMDesc28:
      "Unit, EA-piece/CS-box/PL-pallet, default EA, pushed according to English encoding",
    isBatchMgmtDesc29: "Manage batches, 0-No 1-Yes, default is No",
    isLotMgmtDesc30: "Manage batch numbers, 0-No 1-Yes, default is No",
    supplierCodeDesc31: "Supplier code",
    supplierNameDesc32: "Supplier name",
    currencyIdDesc33: "Currency, see enumeration in Help Center",
    tagPriceDesc34: "Tag price",
    costPriceDesc35: "Cost price",
    unitPriceDesc36: "Retail price",
    purchasePriceDesc37: "Purchase price",
    brandCodeDesc38: "Brand code",
    brandNameDesc39: "Brand name",
    countryCodeDesc40:
      "Country/Region, the same SKU may be sold in different countries, and the price will be different in different countries. SKUs with different tag prices are considered different SKUs.",
    itemCodeDesc41: "item code",
    successDesc42: "success result",
    reasonDesc43: "error code",
    messageDesc44: "error message",
    // -------查询货品
    customeridDesc45: "Customer identity",
    itemCodeDesc46: "Commodity code",
    warehouseCodeDesc47: "Warehouse code",
    startPageDesc48: "Query start page",
    pageSizeDesc49: "Page breaks",
    startdateDesc50: "Item creation start time",
    enddateDesc51: "End time of item creation",
    logisticprovideridDesc52: "Logistic provider id",
    totalDesc53: "Total number",
    pagesDesc54: "Total pages",
    pageDesc55: "Current page",
    pageSizeDesc56: "Pieces per page",
    successDesc57: "Success or not",
    reasonDesc58: "Failure reason",
    baseListDesc59: "BaseList",
    companyCodeDesc60: "Customer code",
    warehouseCodeDesc61: "Warehouse code",
    skuDesc62: "Customer item code",
    shortskuCodeDesc63: "Customer sku code",
    skuStatusDesc64: "Sku status enable scrap draft audit",
    skuTypeDesc65: "Sku type domestic goods cross-border goods",
    chNameDesc66: "Sku name Chinese",
    enNameDesc67: "Sku name English",
    colorDesc68: "Sku color",
    productSizeDesc69: "Sku size",
    unitDesc70: "Minimum selling unit Unit name",
    isElectricityDesc71: "Electricity or not 0-N，1-Y",
    electricityCapacityDesc72: "Electricity capacity Charged capacity (wh)",
    goodsLongDesc73: "Sku length",
    goodsWidthDesc74: "Sku width",
    goodsHeightDesc75: "Sku height",
    weightDesc76: "Sku weight",
    isBaocaiDesc77: "Packing material or not 0-N，1-Y",
    isImeiDesc78: "Manage IMEI or not 0-N，1-Y",
    outstorageControlDesc79: "Outstorage control or not 0-N，1-Y",
    putawayControlDesc80: "Putaway control 0-N，1-Y",
    isDualImeiDesc81: "Enable two IMEIs or not 0-N，1-Y",
    isBatchDesc82: "Batch management or not 0-N，1-Y",
    lifeControlDesc83: "Validity management or not 0-N，1-Y",
    validityPeriodDesc84: "Validity days",
    boxQtyDesc85: "Packing quantity",
    packageUnitDesc86: "Packing unit",
    exportCurrencyDesc87: "Export currency",
    exportUnitPriceDesc88: "Export unit price",
    remarkDesc89: "Remark",
    itemapiDesc: "Use this api to query product information",
    // -----入库单创建
    createinboundDesc: "Create Inbound Order",
    createinboundapiDesc: "create an inbound order through this api",
    warehouseCodeDesc90: "Warehouse Code",
    entryOrderCodeDesc91: "Inbound Order Code",
    customeridDesc92: "Owner Code",
    erpOrderCodeDesc93: "Source Order Code",
    sourceSystemDesc94: "Order Source System",
    outBizNoDesc95: "External Business Order Number",
    storerKeyDesc96: "Operating Company Code",
    orderTypeDesc97: `Inbound Order Type:<br/>
    CGRK – Purchase Inbound<br/>
    THRK – Return Inbound<br/>
    DBRK – Transfer Inbound<br/>
    QTRK – Other Inbound`,
    expectStartTimeDesc98: "Planned Arrival Date: YYYY-MM-DD",
    trackNoDesc99: "Return Tracking Number",
    supplierCodeDesc100: "Supplier Code",
    sourceWarehouseCodeDesc101: "Outbound Warehouse Code",
    sourceStoreCodeDesc102: "Source Store Code",
    remarkDesc103: "Inbound Order Remarks",
    reserved1Desc104: "Reserved Field",
    itemsDesc105: "Product Information List",
    LineNoDesc106: "Inbound Order Line No.",
    itemCodeDesc107: "Goods Code",
    quantityDesc108: "Planned Inbound Quantity",
    inventoryTypeDesc109: "Inventory Type: ZP/CC, default ZP",
    productDateDesc110: "Manufacture Date: YYYY-MM-DD",
    expirationDateDesc111: "Expiration Date: YYYY-MM-DD",
    produceCodeDesc112: "Production Batch Number",
    batchCodeDesc113: "Batch Code",
    remarkDesc114: "Remarks",
    reserved1Desc115: "Reserved Field",
    // -----入库单查询
    queryinboundDesc: "Search inbound orders",
    queryinboundapiDesc: "Query the inbound order through this API",
    customeridDesc122: "Customer Code",
    warehouseCodeDesc123: "Warehouse Code",
    entryOrderCodeDesc124:
      "Inbound Order Codes (comma-separated; required when command = 1)",
    wmsOrderCodeDesc125:
      "WMS Inbound Order Codes (comma-separated; required when command = 3)",
    wmsOrderCodeDesc1255:'Customer Return Tracking Number(s); separate multiple numbers with commas. Required when command=4.',
    commandDesc126:
      "Query Command (1 = by inbound order code; 2 = by order time range; 3 = by WMS inbound order code; 4 = by customer return tracking number; 5 = by completion time)",
    startdateDesc127:
      "Start Time (required when command = 2 or 5; max 1-month range)",
    enddateDesc128: "End Time (required when command = 2 or 5; max 1-month range)",
    batchesDesc129: "Whether to Query Batch Information (0 = No, 1 = Yes)",
    ordertypeDesc130:
      "Inbound Type (CGRK = Purchase Inbound; THRK = Return Inbound; DBRK = Transfer Inbound; QTRK = Other Inbound)",
    statusDesc131:
      "Inbound Status (1 = All; 2 = Not Inbound; 3 = Cancelled; 4 = Partially Inbound; 5 = Fully Inbound; 6 = Terminated [partial inbound completed]; default = 1)",
    successDesc132: "Success or Not",
    reasonDesc133: "Error Code",
    warehouseCodeDesc134: "Warehouse Code",
    orderTypeDesc135:
      "Inbound Type (CGRK = Purchase; THRK = Return; DBRK = Transfer; QTRK = Other)",
    orderTypeCodeDesc136: "Inbound Type Code",
    entryOrderCodeDesc137: "Inbound Order Number",
    wmsOrderCodeDesc138: "WMS Inbound Order Number",
    expectStartTimeDesc139: "Expected Inbound Time",
    createdDesc140: "Inbound Order Creation Time",
    closedAtDesc141: "Inbound Order Closing Time",
    remarkDesc142: "Remarks",
    statusDesc143:
      "Inbound Status (2 = Not Inbound; 3 = Cancelled; 4 = Partially Inbound; 5 = Fully Inbound; 6 = Terminated)",
    itemsDesc144: "Product Information List",
    LineNoDesc145: "Line Number",
    itemCodeDesc146: "Commodity Code",
    itemNameDesc147: "Product Name (Chinese)",
    shortNameDesc148: "Product Name (English)",
    unitDesc149: "Packing Unit",
    quantityDesc150: "Expected Quantity (Planned Quantity)",
    actualQtyDesc151: "Received Quantity",
    batchesDesc152: "Batch List",
    actualQtyDesc153: "Received Quantity (Batch Level)",
    inventoryTypeDesc154: "Inventory Type (ZP/CC; default ZP)",
    productDateDesc155: "Manufacture Date",
    expireDateDesc156: "Expiration Date",
    produceCodeDesc157: "Production Batch Number",
    batchCodeDesc158: "Batch Code",
    // -------入库单回传
    inboundordercallbackapiDesc:
      "Provide the url for receiving the status callback of the inbound order to the technical support. Subsequent changes to the status of the inbound order will be automatically pushed to this url.",
    requestIdDesc159: "Message ID",
    warehouseCodeDesc160: "Warehouse Code",
    customerIdDesc161: "Owner Code",
    storerKeyDesc162: "Operating Company Code",
    entryOrderCodeDesc163: "Customer Order Number",
    entryOrderIdDesc164: "Inbound Order Number",
    entryOrderIdDesc1641: "Return Waybill Number",
    wmsCreatedDesc1642: "WMS_CREATED: 0 = No,1 = Yes",
    deliveryOrderCodeDesc1643: "DELIVERY_ORDER_CODE",
    platformNumberDesc1644: "PLATFORM_NUMBER",
    sourceSystemDesc165: "Order Source System",
    outBizNoDesc166: "External Business Order Number",
    orderTypeDesc167: "Order Type",
    confirmTypeDesc168:
      "Confirm type. Supports multiple receipt confirmations for an inbound order (When confirming after multiple receipts: 0 means final status confirmation with full data return; 1 means intermediate status confirmation with incremental data return; Special case: for the same inbound order, if 0 is received first and later 1 is received, modifying received quantities is allowed.)",
    remarkDesc169: "Remarks",
    statusDesc170:
      "Inbound order status (NEW – Not started; ACCEPT – Accepted; PARTFULFILLED – Partially received; FULFILLED – Fully received; EXCEPTION – Exception; CANCELED – Cancelled; only English codes are transmitted)",
    operateTimeDesc171:
      "Operation time (YYYY-MM-DD HH:MM:SS; when status = FULFILLED, operateTime is the put-away completion time)",
    reserved1Desc172: "Reserved field",
    orderLinesDesc173: "List: Order details",
    LineNoDesc174: "Inbound order line number",
    itemCodeDesc175: "Product code",
    itemNameDesc176: "Product name",
    quantityDesc177: "Planned inbound quantity (in minimum unit quantity)",
    actualQtyDesc178: "Received product quantity",
    inventoryTypeDesc179: "Inventory type ZP/CC, defaults to ZP",
    productDateDesc180: "Production date",
    expireDateDesc181: "Expiration date",
    produceCodeDesc182: "Production batch number",
    batchCodeDesc183: "Batch code",
    reserved1Desc184: "Reserved field",
    reserved1Desc1841: "List of Unique IDs",
    reserved1Desc18411:"Item Unique ID",
    batchesDesc185: "Batch list",
    actualQtyDesc186:
      "Received product quantity — minimum unit quantity received for the current product, returned by batch according to put-away tasks or returned for the entire order.",
    inventoryTypeDesc187: "Inventory type ZP/CC, default ZP",
    productDateDesc188: "Production date",
    expireDateDesc189: "Expiration date",
    produceCodeDesc190: "Production batch number",
    batchCodeDesc191: "Batch code",
    successDesc192: "Response Success Flag",
    codeDesc193: "Response Code (0 = Success, others = Failure)",
    request_idDesc194: "Unique Request ID",
    messageDesc195: "Response Message",
    dataDesc196: "Response Data",
    // -------出库单创建
    outboundorderapiDesc: "Create an outbound order using this API",
    customeridDesc197: "Owner Number",
    warehouseCodeDesc198: "Warehouse Code",
    eccompanyidDesc199: "Owner ID",
    storerKeyDesc200: "Operating Company Code",
    txlogisticidDesc201: "Customer Order Number",
    orderTypeDesc202:
      "Order Type:<br/>JYCK----2C Sales Outbound<br/>BFCK----2C Re-shipment Outbound<br/>YPCK----2C Sample Outbound<br/> QTCK----2C Other Outbound<br/>JITCK----2C Vipshop Outbound<br/>HHCK----2C Exchange Outbound<br/>B2BXSCK----2B Sales Outbound<br/>B2BDBCK----2B Transfer Outbound<br/> CGTH-----2B Purchase Returns<br/>XHCK-----2B Destruction Outbound<br/>B2BQTCK----2B Other Outbound<br/>B2BXNCK----2B Virtual Outbound",
     sourceDesc203:
      "Source Platform: See the Help Center for a list of e-commerce platforms. If no other platform is available, please send OTHER.",
    platformNumberDesc204:
      "Platform Order Number: E-commerce platform order number; if none, can be same as Customer Order Number",
    sourceSystemDesc205:
      "Order Source System: Customer business system (2B order source)",
    outBizNoDesc206:
      "External Business Order Number: Customer system order number",
    payTimeDesc207:
      "Payment Time: E-commerce platform order payment time; format (default Beijing time) yyyy-MM-dd HH:mm:ss",
    createOrderTimeDesc208:
      "Order Time: E-commerce platform order time; format (default Beijing time) yyyy-MM-dd HH:mm:ss",
    requiredStockTimeDesc209:
      "Requested Outbound Time: Format yyyy-MM-dd or yyyy-MM-dd HH:mm:ss (default Beijing time)",
    businessModeDesc210: "B2B/B2C Flag: Default B2C",
    packageIdDesc1: "package Id (TikTok platform orders must be transmitted)",
    senderDesc211: "Sender Information: Optional if no special sender info",
    skuId:'Platform Product Details ID (TikTok platform orders must be transmitted)',
    shippingProviderid:'Logistics service provider ID (TikTok platform orders must be transmitted)',
    countrycodeDesc212:
      "Sender Country Code: China: CHN, Indonesia: IDN, Malaysia: MYS, Vietnam: VNM, Philippines: PHL, Thailand: THA, Singapore: SGP, Cambodia: KHM",
    companyDesc213: "Sender Company",
    nameDesc214: "Sender Name",
    postcodeDesc215: "Sender Postal Code",
    mailboxDesc216: "Sender Email",
    provDesc217: "Sender Province",
    cityDesc218: "Sender City",
    areaDesc219: "Sender District/Area",
    addressDesc2201: "Short address (recommended as this field is required if the country is Saudi Arabia)",
    addressDesc220: "Sender Address 1",
    address2Desc221: "Sender Address 2",
    mobileDesc222: "Sender Mobile",
    phoneDesc223: "Sender Phone",
    receiverDesc224: "Recipient Information",
    shipToDesc225:
      "Store ID: Address 1 (One of three addresses required; only choose one)",
    supplierCodeDesc226:
      "Supplier ID: Address 2 (One of three addresses required; only choose one)",
    countrycodeDesc227:
      "Recipient Country: Address 3 (One of three addresses required; only choose one)",
    addressDesc228: "Recipient Address 1",
    address2Desc229: "Recipient Address 2",
    areaDesc230: "Recipient District/County",
    cityDesc231: "Recipient City",
    provDesc232: "Recipient Province",
    postcodeDesc233: "Recipient Postal Code",
    nameDesc234: "Recipient Name",
    phoneDesc235: "Recipient Phone",
    mobileDesc236: "Recipient Mobile",
    idNumberDesc237: "Recipient ID Number",
    doorNoDesc238: "House/Building Number",
    idNumberUrlDesc239: "Real-name Verification URL",
    transportModeDesc240:
      "Delivery Method: PTWL - Platform Logistics, ZTJ - Self Pickup, SJZL - Merchant Express, CPKD - Warehouse Express, CKPS - Warehouse Delivery",
    carrierDesc241:
      "Logistics Company Code: Required when delivery method is PTWL/SJZL/CPKD; refer to Help Center for codes",
    routeidDesc242: "Logistics Product",
    mailnoDesc243:
      "Carrier Tracking Number: Required when delivery method is PTWL/SJZL",
    labelDesc244: "Waybill URL: Required when delivery method is PTWL",
    remarkDesc245: "Buyer Remark",
    deliveryNoteDesc246: "Seller Remark",
    isCodDesc247: "Cash-on-Delivery Flag: 0 = No, 1 = Yes",
    itemsvalueDesc248: "COD Amount: If value exists, defaults to COD method",
    pricecurrencyDesc249: "COD Currency: Refer to Help Center",
    storeCodeDesc250: "Store Code: Platform store, for operational reference",
    storeNameDesc251: "Store Name",
    isCrossBorderDesc252: "Whether it is a cross-border order, 0 No 1 Yes",
    isPreSaleDesc253: "Whether it is a pre-sale order, 0 No 1 Yes",
    reserved1Desc252: "Reserved Field",
    documentIdentificationDesc252: "Document Identification 13 = Sameday",
    itemsDesc253: "Product Information List",
    lineNoDesc254: "Line Number",
    itemCodeDesc255: "Product Code",
    numberDesc256: "Planned Quantity: Total in smallest unit",
    itemvalueDesc257: "List Price",
    inventoryTypeDesc258: "Inventory Type: ZP/CC, default ZP",
    batchCodeDesc259: "Batch Code",
    produceCodeDesc260: "Lot Number",
    productDateDesc261: "Production Date: YYYY-MM-DD",
    remarkDesc262: "Remarks",
    isGiftDesc263: "Gift Flag: 0 = No, 1 = Yes (Default No)",
    reserved1Desc264: "Reserved Field",
    platformSkuCodeDesc: "Platform SKU Code",
    attachmentUrlDesc: "Product Detail Attachment",
    responseitemsDesc265: "Return List",
    txlogisticidDesc266: "Customer Order Number",
    mailnoDesc267: "Tracking Number",
    billcodeDesc268: "Tracking Number",
    deliveryOrderCodeDesc269: "Outbound Order Number",
    successDesc270: "Success Flag",
    reasonDesc271: "Error Code",
    messageDesc272: "Error Message",
    filesDesc: "Order attachment (Required for Brazil)",
    fileTypeDesc: "Attachment type: INV=Invoice; RCT=Receipt; OTH=Other",
    fileUrlDesc: "Attachment URL, max length 512",
    // -------出库单查询
    outboundorderqueryapiDesc: "Search outbound orders using this API",
    warehouseCodeDesc273: "Warehouse Code",
    serialnumberDesc274:
      "Outbound Order Code: When command=1, provide Courier Number; when command=2, provide ERP Order Number (txlogisticid); when command=3, not required; when command=5, provide Platform Number (platformNumber)",
    customeridDesc275: "Owner Number",
    commandDesc276:
      "Query Command: 1. By Courier Number 2. By ERP Order Number 3. By Order Date Range 5. By Platform Number",
    startdateDesc277:
      'Start Time: Required when command=3; maximum range 30 days; Example: "2023-04-15 00:00:00"',
    enddateDesc278:
      'End Time: Required when command=3; Example: "2023-04-15 00:00:00"',
    pageNoDesc279: "Page Number: Required when command=3",
    pageSizeDesc280:
      "Page Size: Required when command=3; Maximum 200 records per page. Requests over 200 will be rejected",
    ordertypeDesc281:
      "Outbound Type: XSCK – Sales Outbound; DBCK – Transfer Outbound; QTCK – Other Outbound; TGYS – Return to Supplier",
    statusDesc282:
      "Outbound Status: 1. All 2. Pending Picking 3. Shipped 4. Cancelled 5. Pending 6. Picking 7. Pending Review 8. Pending Weighing 9. Pending Outbound (Default: 1. All)",
    countryDesc283:
      "Country: Thailand：THA, Philippines：PHL, Malaysia：MYS, Indonesia：IDN, Vietnam：VNM, China：CHN, Kingdom of Cambodia：KHM, Singapore：SGP, UAE：UAE, Saudi Arabia：KSA, US：USA, Egypt：EGY, Brazil：BRA, Vietnam (New)：VNM_NEW",
    successDesc284: "Success or Not",
    reasonDesc285: "Error Code",
    totalDesc286:
      "Total Count: Returns total number of orders when command=1 or 2",
    startPageDesc287: "Page Number: Returned when command=3",
    pageSizeDesc288: "Current Page Count: Maximum 200 records",
    orderListDesc289: "OrderList",
    customeridDesc290: "Customer ID",
    txlogisticidDesc291: "Customer Order Number",
    mailnoDesc292: "Tracking Number",
    platformNumberDesc400: "Platform Number",
    createdDesc293: "Creation Time",
    sourceDesc294: "Source",
    orderstatusDesc295:
      "Order Status: Pending Picking, Shipped, Cancelled, Pending, Picking, Pending Review, Pending Weighing, Pending Outbound",
    warehouseCodeDesc296: "Warehouse Code",
    businessModeDesc297: "Business Type: Default B2C",
    routeidDesc298: "Route ID",
    outboundtypeDesc299: "Outbound Type",
    transportDesc300: "Shipping Method",
    goodstypeDesc301: "Cargo Type",
    remarkDesc302: "Remarks",
    carrierDesc303: "Carrier",
    endTrackingNoDesc304: "Carrier Tracking Number",
    pickTypeDesc305:
      "Pickup Type: 1 = Pickup from Door 2 = Deliver to Warehouse",
    labelDesc306: "Waybill URL",
    stockTimeDesc307: "Outbound Time",
    senderDesc308: "Sender Info Object",
    companyDesc309: "Sender Company",
    nameDesc310: "Sender Name",
    postcodeDesc311: "Sender Postal Code",
    mailboxDesc312: "Sender Email",
    mobileDesc313: "Sender Mobile",
    phoneDesc314: "Sender Phone",
    countrycodeDesc315: "Sender Country Code",
    provDesc316: "Sender Province",
    cityDesc317: "Sender City",
    areaDesc318: "Sender District/Area",
    addressDesc319: "Sender Address",
    receiverDesc320: "Recipient Info Object",
    companyDesc321: "Recipient Company",
    nameDesc322: "Recipient Name",
    mobileDesc323: "Recipient Phone",
    postcodeDesc324: "Recipient Postal Code",
    countryDesc325: "Recipient Country",
    provDesc326: "Recipient Province",
    cityDesc327: "Recipient City",
    areaDesc328: "Recipient District/Area",
    addressDesc329: "Recipient Address",
    itemsDesc330: "Product Info List",
    lineNoDesc331: "Line Number",
    itemCodeDesc332: "Product Code",
    itemNameDesc333: "Product Name",
    numberDesc334: "Planned Quantity",
    quantityDesc335: "Shipped Quantity",
    snListDesc336: "Unique Code List",
    snDesc337: "Product Unique Code",
    // -------出库单回传
    outboundordercallbackapiDesc:
      "Provide the url for receiving the status callback of the outbound order to the technical support. Subsequent changes to the status of the outbound order will be automatically pushed to this url.",
    requestIdDesc338: "Message ID",
    warehouseCodeDesc339: "Warehouse Code",
    warehouseNameDesc340: "Warehouse Name",
    customerCodeDesc341: "Owner Number",
    storerKeyDesc342: "Operating Company Code",
    providerOrderIdDesc343: "Customer Order Number",
    deliveryOrderCodeDesc344: "Outbound Order Number",
    sourceDesc345: "Source Platform",
    platformNumberDesc346: "Platform Order Number",
    sourceSystemDesc347: "Order Source System",
    outBizNoDesc348: "External Business Order Number",
    scanTimeDesc349: "Outbound Time",
    logisticCodeDesc350: "Logistics Provider Code",
    trackingNumberDesc351: "Waybill Number - Master Number",
    reserved1Desc352: "Reserved Field",
    packagesDesc353: "Package List",
    logisticCodeDesc354: "Logistics Provider Code",
    logisticNameDesc355: "Logistics Provider Name",
    trackingNumberDesc356: "Tracking Number",
    packageCodeDesc357: "Package Number",
    packagesitemsListDesc358: "Package - Product Sublist",
    itemCodeDesc359: "Product Code",
    quantityDesc360: "Quantity",
    packageMaterialListDesc361: "Package - Packaging Material Sublist",
    MaterialtypeDesc362: "Packaging Material Code",
    quantityDesc363: "Packaging Material Quantity: 1",
    orderLinesDesc364: "Order Detail List",
    lineNoDesc365: "Line Number",
    itemCodeDesc366: "Product Code",
    numberDesc367: "Planned Quantity (Total in Smallest Unit)",
    actualQtyDesc368: "Actual Outbound Quantity (Smallest Unit)",
    inventoryTypeDesc369: "Inventory Type: ZP/CC, default ZP",
    batchCodeDesc370: "Batch Code",
    produceCodeDesc371: "Lot Number",
    productDateDesc372: "Production Date: YYYY-MM-DD",
    remarkDesc373: "Remarks",
    reserved1Desc374: "Reserved Field",
    snListDesc375: "Unique Code List",
    snListDesc376: "Product Unique Code",
    batchesDesc377: "Batch List",
    actualQtyDesc378: "Actual Outbound Quantity (Smallest Unit)",
    inventoryTypeDesc379: "Inventory Type: ZP/CC, default ZP",
    batchCodeDesc380: "Batch Number",
    productDateDesc381: "Production Date",
    expireDateDesc382: "Expiration Date",
    produceCodeDesc383: "Production Lot Number",
    supplierCodeDesc384: "Supplier Code",
    supplierNameDesc385: "Supplier Name",
    successDesc386: "Success Flag",
    codeDesc387: "Response Code: 0 = Success, Others = Failure",
    request_idDesc388: "Unique Request ID",
    messageDesc389: "Response Message",
    dataDesc390: "Response Business Parameters",
    // -------单据取消
    cancelorderapiDesc:
      "Cancel inbound and outbound orders using this API, and distinguish between inbound and outbound orders based on the order type",
    customeridDesc391: "Owner number",
    warehouseCodeDesc392: "Warehouse code",
    orderTypeDesc393:
      "Document Type:<br/>CGRK – Purchase Inbound<br/>THRK – Return Inbound<br/>DBRK – Transfer Inbound<br/>QTRK – Other Inbound<br/>XSCK – Sales Outbound<br/>DBCK – Transfer Outbound<br/>QTCK – Other Outbound<br/>TGYS – Return to Supplier",
    orderCodeDesc394:
      "Order Number:<br/>When the document type is Inbound Order, this field should pass the order number to the entryOrderCode field of the Inbound Order interface; when the document type is Outbound Order, this field should pass the order number to the txlogisticid field of the Outbound Order interface.",
    cancelReasonDesc395: "cancellation reason",
    successDesc396: "Success or not",
    errorCodeDesc397: "Error Code",
    messageDesc398: "Error message",

    // 库存查询'
    inventoryqueryDesc: "Get inventory",
    inventoryqueryapiDesc:
      "Obtain product inventory information through this api",
    warehouseCodeDesc399: "Warehouse code",
    customeridDesc400: "Owner Code",
    itemCodeDesc401:
      "Product code: Item Code: Supports multiple itemCodes separated by commas. If itemCode is not provided, only summary data will be returned; if itemCode is provided, detailed data will be returned (up to 100 itemCodes).",
    startPageDesc402: "Page Code",
    pageSizeDesc403: "Number of records per page",
    successDesc404: "Success or not",
    reasonDesc405: "Error Code",
    messageDesc406: "Response Message",
    totalDesc407: "Total number of entries",
    baseListDesc408: "Data list",
    warehouseCodeDesc409: "Warehouse Code",
    itemCodeDesc410: "Product Code ",
    abnormalCountDesc411:
      "Abnormal Stock Quantity: Summary of all non-standard inventory types",
    totalQuantityDesc412:
      "Total in-stock quantity: Summary of all inventory types",
    lockQuantityDesc413:
      "Locked/Pending Put-away Quantity: Inventory that cannot be used due to transfer or stocktake freeze",
    saleQuantityDesc414:
      "Saleable quantity = In-stock quantity - frozen - allocated - locked onHandQty - frozenQty -allocatedQty-inTransitQty",
    pickedQuantityDesc415: "Picked but Not Shipped Quantity Summary",
    storeQuantityDesc416: "Store Quantity = TotalQuantity+Picked_count",
    locationInventoryListDesc417: "Detail List",
    batchCodeDesc418: "Batch Code",
    inventoryTypeDesc419: "Inventory Type",
    productDateDesc420: "Production Date",
    expireDateDesc421: "Expiration Date",
    produceCodeDesc422: "Lot Number",
    lockQuantityDesc423: "LockedQty ",
    saleQuantityDesc424:
      "Available Quantity: Total bin stock − allocated quantity − frozen quantity",
    // 库存快照查询
    InventorysnapshotqueryDesc: "Get historical inventory",
    InventorysnapshotqueryapiDesc:
      "Query inventory information at a specific point in time",
    warehouseCodeDesc425: "Warehouse code",
    customeridDesc426: "Owner Code",
    itemCodeDesc427:
      "Product code: Supports multiple itemCodes separated by commas (up to 100).",
    snapshotDateDesc428: "snapshot_date",
    startPageDesc429: "Page Code",
    pageSizeDesc430: "Number of records per page",
    successDesc431: "Success or not",
    reasonDesc432: "Error Code",
    messageDesc433: "Response Message",
    totalDesc434: "Total number of entries",
    startPageDesc435: "Page Number",
    pageSizeDesc436: "Page Size",
    baseListDesc437: "Data list",
    warehouseCodeDesc438: "Warehouse Code",
    companyCodeDesc439: "Owner Code",
    itemCodeDesc440: "Product Code ",
    barcodesDesc441: "Product Barcode",
    inventoryTypeDesc442: "Inventory Type",
    snapshotDateDesc443: "Archive Date",
    productDateDesc444: "Production Date",
    expireDateDesc445: "Expiration Date",
    batchCodeDesc446: "Batch Code",
    produceCodeDesc447: "Lot Number",
    inventoryAgeDesc448: "Inventory Age",
    onHandQtyDesc449: "In-Stock Quantity",
    availableQtyDesc450: "Available Quantity",
    // 库存异动回传
    InventorychangecallbackDesc: "Inventory change callback",
    InventorychangecallbackapiDesc:
      "Provide the URL for receiving inventory change callback to the technical support; any subsequent inventory changes will be push to this url in real time.",
    customerIdDesc451: "Owner Number",
    changeTimeDesc452: "Change Time",
    warehouseCodeDesc453: "Warehouse Code",
    orderCodeDesc454: "Inventory/Adjustment Order Number",
    reserved1Desc455: "Reserved Field",
    skuDesc456: "Item Change List",
    itemCodeDesc457: "Item Code",
    beforeInventoryTypeDesc458:
      "Inventory Type Before Change: ZP/CC, defaults to ZP",
    afterInventoryTypeDesc459:
      "Inventory Type After Change: ZP/CC, defaults to ZP",
    quantityDesc460:
      "Change Quantity: If only the inventory quantity is adjusted, the inventory type before and after the change remains the same; positive numbers indicate an increase in stock, negative numbers indicate a decrease.",
    batchCodeDesc461: "Batch Code",
    produceCodeDesc462: "Production Lot Number",
    remarkDesc463: "Remark",
    reserved1Desc464: "Reserved Field",
    totalQuantityDesc465: "Total Stock After Change",
    requestIdDesc466: "Message ID",
    pushTimeDesc467:
      "Push Time: The time the system pushes to upstream, default UTC+8; include timezone indicator when passing the parameter.",
    remarkDesc468: "Remark: Adjustment reason + additional notes",
    successDesc469: "Success or not",
    codeDesc470: "Response Code (0: Success, Others: Failure)",
    request_idDesc471: "Unique Request ID",
    messageDesc472: "Response Description",
    dataDesc473: "Response Business Parameters",
    // 其他-查询备货仓库
    warehousequeryDesc: "Search stock warehouse",
    warehousequeryapiDesc: "Query all warehouses associated with the shipper",
    customeridDesc474: "Customer identity",
    successDesc475: "Success or not",
    reasonDesc476: "Failure reason",
    baseListDesc477: "BaseList",
    warehouseCodeDesc478: "Warehouse code",
    warehouseNameDesc479: "Warehouse name",
    // 出库单轨迹
    trackDesc: "Get outbound order tracking",
    trackapiDesc: "Get logistics tracking information of outbound orders",
    warehouseCodeDesc480: "Warehouse Code",
    customeridDesc481: "Customer identity",
    trackingNoListDesc482: "Query command (maximum 50 entries)",
    successDesc483: "Success or not",
    reasonDesc484: "Failure reason",
    totalDesc485: "Total number of entries",
    dataDesc486: "Data List",
    trackingNoDesc487: "Tracking Number",
    tracesDesc488: "Detailed Tracking Info",
    statusDesc489: "Status",
    scanTypeDesc490: "Scan Node",
    scanTimeDesc491: "Scan Time",
    descDesc492: "Tracking Description",
    // 其他——合单预报
    CombinedorderforecastDesc: "Combined orders forecast",
    CombinedorderforecastapiDesc:
      "Used for order consolidation scenarios. This interface pushes pending consolidated packages to the WMS. This is a customized interface; please consult technical support for details.",
    warehouseCodeDesc493: "Warehouse Code ",
    combinedOrderCodeDesc494: "Customer identity",
    sourcePlatformDesc495: "Source Platform",
    packageCodeDesc496: "Package Collection",
    packageCodeDesc497: "Package Number",
    forwardPackageCodeDesc498: "Forwarding Tracking Number",
    base64EncodeContentDesc499: "Forwarding Print Link",
    successDesc500: "Success or not: 1-success Others-Failure",
    messageDesc501: "Failure reason",
    combinedOrderCodeDesc502: "Customer identity",
    // 设备登录
    DeviceloginDesc: "Device Login",
    DeviceloginapiDesc:
      "Used for device integration scenarios, supporting device login authentication.",
    desc499:'Message Format',
    desc500: "Device Type",
    desc501: "Device Manufacturer",
    desc502: "Device Serial Number",
    weightDesc506: 'Message Format',
    weightDesc507: 'Device Type',
    weightDesc508: 'Device Manufacturer',
    weightDesc509: 'Device Serial Number',
    weightDesc510: 'client returned after login',
    weightDesc511: 'token returned after login',
    weightDesc512: 'Device Login User Code',
    usenameDesc503: "Device Login Username",
    passwordDesc504: "Device Login Password",
    codeDesc505: "Response Code",
    msgDesc506: "Response Message",
    dataDesc507: "Response Body",
    usernameDesc508: "Device Login Username",
    tokenDesc509: "Device Login Token",
    clientDesc510: "Device Login Client",
    defaultWarehouseCodeDesc511: "Device Default Warehouse",
    traceIdDesc512: "Trace Identifier",
    // 其他——称重设备上传重量
    WeighingequipmentDesc: "Weighing equipment uploads weight",
    WeighingequipmentapiDesc:
      "Used for docking scenarios of weighing equipment; supports weighing equipment to push weight data to WMS.",
    referenceCodeDesc513: "WaybillCode",
    warehouseCodeDesc514: "WarehouseCode",
    weightDesc515: "Weight: 2 digits integer, 1 decimal place, unit KG",
    codeDesc516: "Response Code",
    msgDesc517: "Response Message",
    // 其他——容器绑定
    containerBindDesc: "Container Bind",
    containerBindapiDesc: "Used for sorting-slot container binding; supports binding packages/baskets to containers.",
    logisticsInterfaceDesc518: "Content in Json Format",
    dataDigestDesc519: "Signature result",
    msgTypeDesc520: "Message type",
    eccompanyidDesc521: "Message provider ID",
    warehouseCodeDesc522: "Warehouse Code",
    taskCodeDesc523: "Pick task code",
    orderLinesDesc524: "Binding detail list",
    basketNoDesc525: "Basket No (choose basketNo or packageCode)",
    packageCodeDesc526: "Package Code (choose basketNo or packageCode)",
    boxCodeDesc527: "Box Code",
    successDesc528: "Success or not",
    reasonDesc529: "Failure reason",
    successListDesc530: "Success list",
    resultBasketNoDesc531: "Basket No",
    resultPackageCodeDesc532: "Package Code",
    resultBoxCodeDesc533: "Box Code",
    resultShipmentCodeDesc534: "Shipment Code",
    resultFailReasonDesc535: "Failure reason",
    failListDesc536: "Failure list"
  },
  onlineDoc: {
    requiredYes: "Yes",
    requiredNo: "No",
    logistics_interface_desc: "JSON format content",
    data_digest_desc: "Signature result",
    msg_type_desc: "Message type",
    eccompanyid_desc: "Message provider ID",
    地址: "Address: Use the URL provided by the access party",
    请求方法: "Request method：",
    数据类型: "type of data：",
    响应类型: "Response type：",
    接口说明: "Interface Description",
    接口信息: "Interface information",
    参数描述: "Parameter Description",
    Headers: "Headers",
    请求参数: "Request parameter",
    业务参数: "Business parameters",
    sender类型说明: "Sender type description",
    receiver类型说明: "Receiver type description",
    items类型说明: "Item type description",
    customsInfo类型说明: "CustomsInfo type description",
    details类型说明: "details type description",
    报文描述: "Message description",
    响应参数: "Response parameters",
    data类型说明: "Data type description",
    请求示例: "Request example",
    返回示例: "Return example",
    返回成功样例: "Success response example",
    返回失败样例: "Failure response example",
    错误代码: "Error code",
    错误编码: "Error code",
    错误描述: "Error Description",
    测试地址: "Test address：",
    正式地址: "Official address：",
    测试apiAccount: "Test apiAccount：",
    测试privateKey: "Test privateKey：",
    属性名: "Parameter name",
    属性类型: "Parameter type",
    变量名: "Properties",
    说明: "Description",
    是否必填: "required",
    示例: "Example",
    描述: "Description",
    OrderDescription_1:
      "Customers who have signed a contract with the platform can create/modify orders through this interface. The current order creation interface supports order modification, that is, if the customer order number (txlogisticId) already exists and the corresponding order has not been collected, directly modify the existing order. If the recipient address changes, get the latest three-segment code/big end return;",
    OrderDescription_2: "Query the order created by the new order interface",
    OrderDescription_3:
      "Cancel orders generated through the new order interface",
    OrderDescription_4:
      "After the access party has provided the logistics status to return relevant information and completed the order placement operation, when the order-related status changes, the system will actively push the logistics information according to the push account configured by the access party.",
    OrderDescription_5: `Non-office contract customers can create individual customer orders through this interface. At present, the individual customer shipping interface supports order modification, that is, if the customer order number (txlogisticId) already exists and the corresponding order has not been collected, the existing order will be directly modified. You can upload the sender's information through the "real-name information upload" interface;`,
    通过单号查询快件的轨迹信息:
      "Query the track information of the shipment through the tracking number",
    OrderDescription_6:
      "Users can obtain template information of electronic sheet through the interface",
    OrderDescription_7:
      "Through the interface, the user can apply for returning the waybill that has been picked up",
    OrderDescription_8:
      "Get the three-segment code from sender's Add. and receiver's Add.",
    OrderDescription_9: "Return and Exchange Interface",
    trackDescription_1:
      "Query the track information of the shipment through the tracking number",
    trackDescription_2: `Subscribe to Polar Rabbit to push the waybill number of the logistics track <br/> <strong>Note: Need to provide the URL of the return logistics track</strong> `,
    trackDescription_2_1: `Subscribe to Polar Rabbit to push the waybill number of the logistics track, Note: Need to provide the URL of the return logistics track`,
    trackDescription_3:
      "After the access party has provided the delivery track push related information and completed the order placement operation, when the order-related waybill track changes, the system will actively push the logistics information according to the push account configured by the access party.",
    // 表单描述翻译
    接入方在平台的api账户标识:
      "The third party's account use to access the platform",
    通过地址查询对应的三段码信息:
      "Get the three-segment code from sender's Add. and receiver's Add.",
    签名字符串: "Signature string",
    "时间戳，毫秒": "Timestamp, milliseconds",
    业务参数模块内json格式的string类型:
      "The string type in json format in the business parameter module",
    "客户编码（联系出货网点提供）": "Customer code (Proved by origin station)",
    sign: "Signature, Base64 (Md5 (customer number + cipher text + privateKey)), where the cipher text: MD5 (plain text password + jadada236t2) followed by uppercase",
    signnew:
      "1. MD5 signature, Base64(Md5(customer number+ciphertext+privateKey)), where ciphertext: MD5 (plaintext password+jadada236t2) followed by uppercase <br />2. SHA256 signature, Sha256 (customer number + ciphertext + privateKey), where ciphertext: Sha256 (plaintext password)",
    合作网点: "Cooperation outlets",
    "客户订单号（传客户自己系统的订单号）":
      "Customer order number (pass the order number of the customer’s own system)",
    ExpressType:
      "Express types:<br/> EZ：standard（UAE)；<br/>EZKSA：standard（KSA)；<br/>Reverse: Reverse（KSA）；<br/>ReverseUAE: Reverse（UAE）<br/>SDD:Same Day（KSA）<br/>SDDUAE:Same Day（UAE）<br/>SCH: SCHEDULE（KSA）<br/>SCHUAE: SCHEDULE（UAE）",
    expressQueryType:
      "0.Express Side Sheet Template <br/>1. Cross-Border Parts Single Template",
    OrderType:
      "Order type (customer number is monthly settlement) 1. Individual customers; 2. Monthly settlement;",
    服务类型:
      "Type of service: <br /> 02 store delivery <br /> 01 pick up at door",
    serviceTypeCode: "C01: International <br/>C02: Domestic",
    派送类型: "Delivery type: <br />03 Self pickup；<br />04 Deliver to door",
    paymentMethod: `Payment method: PP_PM ("Monthly payment by shipper")`,
    寄件信息对象: "Shipment information object",
    收件信息对象: "Receiving information object",
    LC_pick_up_start_time:
      "Appointed pick up time, starts at yyyy-MM-dd HH:mm:ss",
    CLC_door_to_door_end_time:
      "Appointed pick up time, ends at yyyy-MM-dd HH:mm:ss",
    itemtType:
      "Item type (Match to the Item type on the waybill): <p>ITN1 Clothes</p>  <p>ITN2 Document</p>  <p>ITN3 Food</p>  <p>ITN4  others</p>  <p>ITN5  Digital product</p>  <p>ITN6  Daily necessities</p>  <p>ITN7 Fragile Items</p>",
    Length: "Length, cm",
    Width: "Width, cm",
    Height: "Height, cm",
    volume: "volume",
    Weight: "Weight, unit kg, range 0.01-30",
    包裹总件数: "Total number of packages",
    包裹总票数: "Total number of tickets for the package (<=999)",
    "代收货款金额 (数值型)": "COD amount (numeric)",
    "代收货款金额 (数值型)1": "COD amount (Condition is required,numeric)",
    collectionPayment: "COD currency",
    collectionPayment1: "COD currency (Condition is required)",
    offerFee:
      "Insurance amount (numeric type), unit, such as SAR, AED, USD, RMB, (0~99999999, supports 4 decimal places)",
    保价费: "Insurance fee",
    备注: "Remark",
    商品信息列表: "Product information list",
    客户信息: "Customer Information",
    寄件人姓名: "Sender name",
    寄件公司: "Sender company",
    寄件邮编: "Sender zip code",
    寄件邮箱: "Sender mailbox",
    SendingMobilePhone:
      "Sender mobile phone (required to fill in mobile phone or telephone）",
    SendingPhoneNumber:
      "Sender telephone (required to fill in mobile phone or telephone)",
    ThreeCharacterSending:
      "Three-character country code of sender country (eg UAE=UAE, China=CHN, KSA=KSA)",
    寄件酋长国: "Sender province",
    寄件区域: "Sender city",
    区域1: "Sender area",
    寄件街道: "Sender street",
    ShippingDetailedAddress:
      "Sender detailed address (Emirate + area + street + detailed address)",
    寄件区号: "Sender area code",
    收件人姓名: "The recipient's name",
    收件人证件号码: "Recipient ID numbers",
    收件公司: "receiver",
    收件邮编: "Receiver postal code",
    收件邮箱: "Receiver mailbox",
    ReceivingMobilephone:
      "Receiver mobile phone (required to fill in mobile phone or telephone)",
    ReceivingPhoneNumber:
      "Receiver telephone (required to fill in mobile phone or telephone)",
    ThreeCharacterRecipient:
      "Three-character code of receiver country (eg UAE=UAE, China=CHN, KSA=KSA) <p>The delivery address must be consistent with the custonher's location</p>",
    收件酋长国: "Receiver Province",
    收件区域: "Receiver City",
    区域2: "Receiver Area",
    收件街道: "Receiver street",
    ReceivingDetailedAddress:
      "Receiver detailed address (Province + city + street + detailed address)",
    收件区号: "Receiver area code",
    物品类型:
      "Item type:<p>ITN1 Clothes</p>  <p>ITN2 Document</p>  <p>ITN3 Food</p>  <p>ITN4  others</p>  <p>ITN5  Digital product</p>  <p>ITN6  Daily necessities</p>  <p>ITN7 Fragile Items</p>",
    物品名称: "Item Name",
    物品中文名称: "Chinese name of the item",
    物品英文名称: "English name of the item",
    cases: "Number of cases, ≤ 1",
    "申报价值(数值型)":
      "Declared value (numerical type), The value of a single item",
    priceCurrency:
      "Declare the payment currency (default domestic currency, such as: AED), The declared currency of a single order cannot be inconsistent",
    物品描述: "item description",
    退换货: "1: Return </br > 2: return and exchange",
    退货单单号: "Return order No",
    换货单单号:
      "Replacement Order No (Returns when returnandexchangetype is 2)",
    商品URL: "Product URL",
    "货物数量 跨境件报关需要填写":
      "The quantity of goods needs to be filled in for cross-border customs declaration",
    货物单位:
      "Cargo unit, such as: pieces and set, cross-border cargo declaration needs to be filled in",
    原产地国别:
      "Country of origin of the product, cross-border customs declaration needs to be filled in",
    货物产品国检备案编号:
      "National inspection record number of goods and products, cross-border customs declaration needs to be filled in",
    商品海关备案号: "Commodity customs record number",
    商品行邮税号:
      "Commodity postal tax number is required for cross-border customs declaration",
    海关编码: "Customs code is required for cross-border customs declaration",
    商品编号:
      "Commodity No. Cross-border customs declaration needs to be filled in",
    货物品牌:
      "Cargo brand cross-border customs declaration needs to be filled in",
    货物规格型号:
      "Cargo specifications and models, cross-border cargo declarations need to be filled in",
    生产厂家: "Manufacturers need to fill in cross-border customs declaration",
    托寄物声明价值:
      "The declared value of the consignment is required for cross-border customs declaration",
    托寄物声明价值币别:
      "Consignment declared value currency, cross-border customs declaration needs to be filled in",
    客户支付的运费:
      "Amount of shippment fee paid is required for cross-border customs declaration",
    "返回码，见附录": "Return code, see appendix",
    业务数据: "Business data",
    集包地: "Collection land",
    返回客户订单号: "Return customer order number",
    订单创建时间: "Order creation time yyyy-MM-dd HH:mm:ss",
    三段码online:
      "Three-segment code (get the three-segment code first to return to the three-segment code, if there is no three-segment code, return to the big pen)",
    参考总运费: "Refer to the total freight (numerical type)",
    查询命令:
      "Query command 1. Query by customer order number 2. Query by waybill number (check order status with waybill number) 3. Query by time period of order (check order) (query by time period returns unlimited number) 4. Order serial number",
    command:
      "ccommand=1 customer order number query; command=2 waybill number temporarily; command=4 order number (internal company) supports 200; Command=1, 2 or 3 is required",
    startDate:
      "Start time (24 hour system: yyyy-MM-dd HH:mm:ss Required when command is 3) Order Time (Required when Command = 3)",
    endDate:
      "End Time (24 hour system: yyyy-MM-dd HH:mm:ss Required when command is 3) Time Range (7 days at the most, Required when Command = 3)",
    status:
      "Status (the order status is taken from the status table below, filtered data is used, all by default): canceled 104: picked up 103: dispatched salesperson    102: dispatched outlets 101: not dispatched 100",
    "command = 3 时必填": "Required when command = 3",
    系统订单号: "System order number",
    "客户订单号-客户自己系统的订单号":
      "Customer order number (The order number of the customer's own system)",
    快件类型: `Express type: only supports "standard, express`,
    订单状态:
      "Order status: <br />104: Cancelled;<br /> 103: Picked up;<br /> 102: Arranged Operator; <br /> 101: Arrange Operation Station;<br /> 100: No Arrangement",
    订单类型: "Order type: 01 individual customers 02 month settlement",
    三段码: "Three-segment code",
    "客户编码（订单类型传2时，必填）":
      "Customer code (Proved by origin station)",
    "订单类型  1（散客），2（协议客户）":
      "Order type <br />1: individual customers <br />2: contract customers",
    取消原因: "Reason for Cancellation",
    退件原因: "Return reason",
    运单号: "Waybill number",
    "更新订单时，必传": "When updating the order, it must be passed",
    客户订单号: "customer order no",
    operateType: `In the event, the customer fills in "Add" to add an order; if the customer submits "Update", then an order is updated.<p>1 Adding</p><p>2 Modifying</p>`,
    客户订单编号: "Customer order number",
    极兔运单编号: "J&T Waybill Number",
    "网点名称（“已调派业务员”回传）": `Station Name (Returned by Assgined Courier)`,
    "业务员名称（“已调派业务员”回传）": `Courier Name (Returned by Assgined Courie)`,
    "业务员联系方式（“已调派业务员”回传）": `Courier Cantact Infomation (Returned by Assgined Courie)`,
    极兔订单编号: "J&T Order Number",
    "重量（“已揽收”“已取件”时回传）": `Weight (Returned when collected or picked up)`,
    "订单取消原因（“已取消”时回传）": `Reason for order cancellation (Returned when collected or picked)`,
    "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)": `Status ("Courier Assigned", "Collected", "Picked up", "Cancelled")`,
    时间: "time",
    承运商编码: "Carrier code",
    "业务员编码（联系出货网点提供，且采用网点编码签名）":
      "Salesman code (provided by contacting the shipping outlet, and signed by the outlet code)",
    "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写":
      "Signature, Base64 (Md5 (customer code/salesman code+ciphertext+privateKey)), where the ciphertext: MD5 (plaintext password/point code+jadada236t2) followed by capital",
    运单编号: "Waybill number",
    "快件类型：EZ(标准快递)": "Express type: EZ (standard express)",
    "订单类型  1、散客；": "Order type 1. Individual customers;",
    "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）": `Payment method CC_CASH ("Pay and cash settlement"); PP_CASH ("Pay and cash settlement")`,
    "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss":
      "The end time of the logistics company's pick-up yyyy-MM-dd HH:mm:ss",
    "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单":
      "Waybill number. Multiple waybill numbers are separated by English commas. Currently, it supports querying up to 30 waybills at one time.",
    运单轨迹详情: "Waybill track details",
    扫描时间: "Scan time",
    轨迹描述: "Transition Description",
    scanType:
      "Scan type : <p>10：Pickup scan</p> <p>50：Station sending/DC sending</p> <p>92：Station arrival</p> <p>90：DC arrival</p><p>94：Delivery scan</p><p>100：Sign scan</p><p>110：Abnormal parcel scan</p><p>172：Returned parcel scan</p><p>402：Change Address scan</p> <p>1001:Returned signed</p> <p>301: International warehousing</p> <p>302: International Air Arrival</p> <p>303: International Air Shipment</p> <p>304: Customs declaration scan</p> <p>305: Customs clearance scan</p>",
    scanTypeCode: "Scan type code",
    扫描网点名称: "Scan Station name",
    扫描网点ID: "Scan Station ID",
    业务员姓名: "Courier Name",
    业务员联系方式: "Courier contact information",
    扫描网点联系方式: "Contact Information of Scan Station",
    扫描网点省份: "Scan Province",
    扫描网点城市: "Scan City",
    "扫描网点区/县": "Scan area",
    "上一站(到件)或下一站名称(发件)":
      "Last stop (arrival) or next stop name (sent)",
    "下一站省份（发件扫描类型时提供）":
      "Next stop Province (provided when sending scan type)",
    "下一站城市（发件扫描类型时提供）":
      "Next stop city (provided when sending scan type)",
    "下一站区/县（发件扫描类型时提供）":
      "Next stop district/county (provided when sending scan type)",
    "签收图片（签收扫描时，展示该数据）":
      "Sign in picture (show the data when signing in for scanning)",
    "电子签名（签收扫描时，展示该数据）":
      "Electronic signature (show the data when signing in for scanning)",
    快递轨迹详情: "Courier tracking details",
    订阅节点:
      "Subscription node: <br />10&50&92&90&94&100&110&172&402&1001&301&302&303&304&305  <p>10：Pickup scan</p> <p>50：Station sending/DC sending</p> <p>92：Station arrival</p> <p>90：DC arrival</p><p>94：Delivery scan</p><p>100：Sign scan</p><p>110：Abnormal parcel scan</p><p>172：Returned parcel scan</p><p>402：Change Address scan</p> <p>1001: Returned signed</p> <p>301: International warehousing</p> <p>302: International Air Arrival</p> <p>303: International Air Shipment</p> <p>304: Customs declaration scan</p> <p>305: Customs clearance scan</p>",
    数组: "Array",
    "明文密码:H5CD3zE6": "Clear text password: H5CD3zE6",
    电子面单标签: "Electronic surface single label",
    电子面单链接: "Electronic surface single url",
    平台名称: "Platform",
    客户账户: "Customer Account",
    isUnpackEnabled:
      "Allow customer to open the box for inspection<p>0 no</p><p>1 yes</p>",
    needLogo: "0: yes; <br />1: no",
    寄件经度: "Sender Longitude",
    寄件纬度: "Sender Latitude",
    收件经度: "Receiver Longitude",
    收件纬度: "Receiver Latitude",
    "经度（在问题件扫描时回传）":
      "Longitude (returned when the problem piece is scanned)",
    "纬度（在问题件扫描时回传）":
      "Latitude  (returned when the problem piece is scanned)",
    "OTP验证码（签收扫描类型时提供）":
      "OTP verification code (provided when signing for scan type)",
    商户号: "Business Number",
    快件预报接口:
      "It is used for cross-border customers to synchronize shipment information in shipment batches, such as MAWB/RAWB, package number, and shipment order number information. After the shipments are sorted, packed and weighed, and booked by air/load in the warehouse area, the information of the shipments in the relevant batches is returned through the interface.",
    航空主单号: "MAWB",
    托盘号: "pallet No",
    包号: "package No",
    包重量: "Packge Weight",
    封包时间: "Closing Time",
    包列表: "Packge list",
    航空预报接口:
      "It is used for cross-border customers to synchronize air, land and sea information of shipment batches. After completing the booking and obtaining the carrier's flight information, the terminal J&T Express is synchronized through the interface, which is convenient for the terminal to arrange customs clearance and LastMile delivery.",
    航空主单号陆运主单号: "MAWB",
    航班号: "Flight No",
    航班日期: "Flight Date",
    航班预计起飞时间: "ETD",
    航班预计到达时间: "ETA",
    航班实际起飞时间: "Actual Flight Departure Time",
    航班实际到达时间: "Actual Flight Arrival Time",
    运送重量: "Shipping Weight",
    起始地国家: "Origin Country <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    目的地国家: "Destination Country <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    起始地机场: "Departure Airport",
    目的地机场: "Destination Airport",
    目的港: "Destination Port <br /> DMM <br /> JED <br /> RUH <br />DXB",
    删除类型:
      "delete type <br /> PALLET：pallet <br /> PACKAGE_INFO ：package information <br /> ORDER：order",
    "批次号（快件预报删除）":
      "batch number（type includes PALLET 、PACKAGE_INFO required）",
    "托盘号（快件预报删除）":
      "PALLET number（type includes PALLET、PACKAGE_INFO required）",
    "包号（快件预报删除）":
      "package number（type includes PACKAGE_INFO required）",
    "运单号（快件预报删除）": "Waybill number（type includes ORDER required）",
    快件预报删除接口:
      "Use this interface to delete the information submitted in the shipment forecast",
    托盘列表: "pallet list",
    订单列表: "Order List",
    签名类型: "Signature type 1.MD5(default) 2.SHA256",
    "问题件图片（在问题件扫描时提供）":
      "Picture of the problem part (provided when the problem part is scanned)",
    问题件二级编码: "Problem piece secondary code",
    预估运费查询: "Estimated freight query",
    预估运费查询说明:
      "Estimate the freight through the mailing address and item information",
    "⻓，cm": "long，cm",
    "宽，cm": "wide，cm",
    "⾼，cm": "height，cm",
    重量: "Weight (positive number), unit: kg, range: 0.01-30, default: 0.02",
    "运费总价（单位：元），保留两位⼩数":
      "Total freight price (unit: yuan), two digits reserved",
    subscribeDesc:
      "The customer code of the open platform customer who needs to receive the payment for goods according to the subscription requirements of apiaccount",
    subscribeOtherDesc:
      "Push the payment for goods collected by financial settlement to the customer. The customer needs to configure the return address on the open platform.",
    登记时间: "Registration time",
    订单流水号: "Order serial number",
    返款进度:
      "Repayment progress\n1:Pending application\n2:To be reviewed\n3:Payment to be refunded\n4:Refund",
    "应付客户货款⾦额": "Amount payable to customers",
    总运单票数: "Total number of waybill tickets",
    运单列表信息: "Waybill list information",
    "到件图片（到件扫描时，展示该数据，多张图片以逗号分割）":
      "Incoming picture (when the incoming picture is scanned, the data is displayed, multiple pictures are separated by commas)",
    预约派送日期: "Scheduled delivery date",
    预约派送时间段: "Scheduled delivery time",
    国家三字码: "country code",
    省份: "province",
    城市: "City",
    区域: "area",
    详细地址: "Address",
    "true 成功 false 失败": "true success false failure",
    客户可通过此接口进行预约派送:
      "Customers can schedule delivery through this API",
    OrderDescription_10:
      "Customers who have signed contracts with the platform can create export international express orders through this interface.",
    "业务参数，各接口的入参json报文":
      "Business parameters, input parameter JSON messages for each interface.",
    "默认C03-出国国际件": "Default: C03 - Export International Shipments",
    CharacterSending:
      "Sender country 2/3-letter code (UAE = AE/UAE) – only UAE is supported.",
    CharacterRecipient: "Two-letter code of the recipient's country",
    数量: "number",
    purposeOfShipment:
      "Shipping purpose (e.g., 1, 2, 3)<br/>1 corresponds to Gift<br/>2 corresponds to Personal not for sale<br/>3 corresponds to General Items",
    原产地: "country of origin",
    internationalExportExpressType: "Shipment type: only supports ExportUAE"
  },
  apiTestDoc: {
    接口说明: "Interface Description",
    Headers: "Headers",
    Body: "Body",
    Response: "Response",
    错误代码: "Error code",
    错误编码: "Error code",
    错误描述: "Error Description",
    请求头Headers参数: "Request Headers parameters",
    不能为空: "can not be empty",
    参数: "parameter",
    业务参数签名失败: "Business parameter signature verification failed",
    修改订单失败: "Order modification failed",
    区域不合法: "Illegal region",
    城市不合法: "Illegal city",
    省份不合法: "Illegal province",
    查不到数据: "Data not found",
    下单失败: "Order placement failed",
    发件人信息不全: "Incomplete sender information",
    "订单重复,无需重复下单！":
      "Duplicate order, don't place the order repeatedly!",
    收件人信息不全: "Incomplete recipient information",
    电话号码不能为空: "Phone number cannot be empty",
    地址信息不全: "Incomplete address information",
    "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法":
      "Please check whether the order type, service type, delivery type, item type, shipment type and settlement method are legal",
    "请检查服务类型是否合法值为 01或 02":
      "Please check if the service type is legal with the value of 01 or 02",
    上门服务时间信息不全: "Incomplete service time information",
    重量信息不合法: "The weight information is not legal",
    物品信息不全: "Incomplete item information",
    物品名称不全: "Incomplete item name",
    物品类型不全: "Incomplete item type",
    "客户订单号已存在,无法下单！":
      "Customer order number already exists, cannot place an order!",
    姓名信息非法: "Illegal name information",
    公司信息过长: "Company information is too long",
    联系信息过长: "Contact information is too long",
    邮编或邮箱信息非法: "Postcode or email address is illegal",
    价格信息非法: "Price information is illegal",
    "备注、描述、链接信息非法": "Comments, descriptions, links are illegal",
    地址信息过长: "Too much address information",
    街道信息过长: "Street information is too long",
    包裹总件数无效: "The total number of parcels is invalid",
    暂未开通代收货款业务: "COD service is not opened",
    "支付方式不匹配,PP_CASH,CC_CASH,PP_MM":
      "The payment method does not match,PP_CASH,CC_CASH,PP_MM",
    已取件状态不可修改: "Picked up status can not be modified",
    已取消状态不可修改: "Cancelled status can not be modified",
    "更新订单失败，请稍后重试！":
      "Updating order failed, please try again later!",
    始发地信息不全: "Incomplete information of origin",
    收货地信息不全: "Incomplete information of receiving place",
    暂未开通保价服务: "The insurance service is not yet available",
    保价金额需大于等于0:
      "The insured amount must be greater than or equal to 0",
    时间范围非法: "Illegal time range",
    页码非法: "Illegal page number",
    超过数据限制: "Data limit exceeded",
    客户订单号不能为空或过长:
      "Customer order number cannot be empty or too long",
    取消原因不能为空: "Cancellation reason cannot be empty",
    运单号非法: "Illegal waybill number",
    运单号个数超过30: "The quantity of the waybill number exceeds 30",
    运单号个数超过1000: "The quantity of the waybill number exceeds 1000",
    物品数量非法: "Illegal item quantity",
    非法金额: "Illegal amount",
    必填参数为空: "Required parameter is empty",
    "总数量不能超过 999": "totalQuantity cannot exceed 999",
    客户编码不合法: "Customer code is illegal",
    发件人信息不完整: "Incomplete sender information",
    收件人信息不完整: "Incomplete receiver information",
    手机号码长度错误: "MOBILE_LENGTH_ERROR",
    请填写正确的寄件省份: "Please fill in the correct sending prov",
    COD代收货款不能超过3万:
      "The COD(collection on delivery) cannot be greater than 30000",
    货到付款金额不能小于:
      "The COD(collection on delivery) cannot be less than 0.01",
    货品类型信息不完整: "Incomplete item type",
    "请检查服务类型是否合法（仅支持 01 或 02）":
      "Please check if the service type is legal with the value of 01 or 02",
    请填写正确的派送类型: "Please fill in the correct delivery type",
    请填写正确的运输类型: "Please fill in the correct shipment type",
    快递类型错误: "Express type error",
    服务类型代码校验失败: "ServiceTypeCode validation failed",
    仓库标识错误: "isWarehouse error",
    条码不能为空: "barcode cannot be empty",
    商品编码不能为空: "item_code cannot be empty",
    "SKU 编码不能为空": "sku_code cannot be empty",
    参数长度超过最大限制: "The parameter length exceeds the maximum limit",
    "运费不能小于 0": "The OfferFee cannot be lessthan 0",
    运费不合法: "The offerFee is invalid",
    收货地址与客户所在位置不一致:
      "The delivery address does not match the customer is location",
    未找到收件人国家: "Recipient country not found",
    币种不合法: "Invalid currency",
    订单申报币种不匹配: "Order declaration currency mismatch",
    寄件国家编码或者名称不能为空: "%s can not be empty",
    高价值包裹必须填写收件人证件号码:
      "High-value packages must fill in the receiveridNumber",
    订单申报币种: "Order declaration currency",
    货物寄送目的填写错误: "The purpose of shipment is filled in incorrectly"
  },
  ...lang
};

export default messages;
